/* eslint-disable no-undef */
import React from 'react';
import { send } from 'server';
import { getId } from '@core/js/hooks/device';
import * as pas from '@core/js/hooks/auth/pas';
import { dispatcher } from '@core/js/backbone/dispatcher';
import { createRoot } from 'react-dom/client';
import { registerPortlets } from '@core/js/backbone/portlets';
import { getUserAgent } from '@core/js/utils/device.util';
import { scrollService } from '@core/js/services/scroll.service';
import { ReCaptchaBare, ERRORS } from '@core/js/components/main/ReCaptcha';
import { addBackUrls } from '@core/js/components/main/QuickDeposit/Deposit/helpers';
import { performRedirect } from '@core/js/components/main/QuickDeposit/utils/redirect';
import { LoginLimitsForm } from '@theme/js/components/main/ResponsibleGaming/RegistrationLoginLimits/LoginLimitsForm';

export { pas };
export { dispatcher };
export { getUserAgent };
export { registerPortlets };
export { send };

export const getDeviceId = () => getId();
export const cashier = {
    addBackUrls,
    performRedirect
};
export const {
    enableBodyScroll,
    disableBodyScroll
} = scrollService;

export const reCaptcha = selector => {
    let root;

    return {
        render: options => {
            root = createRoot(document.querySelector(selector));

            root.render(<ReCaptchaBare {...options} />);
        },
        remove: () => root && root?.unmount(),
        ERRORS
    };
};

/* TotalCasino changes */
export const loginLimitsReg = (selector) => {
    let root;
    return {
        render: () => {
            root ??= createRoot(document.querySelector(selector));

            root.render(<LoginLimitsForm />);
        },
        remove: () => root && root?.unmount()
    };
};
/* TotalCasino changes */
